import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class OfficeR06 extends HObject {
  static meshes = []
  static loadRequest = false
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
    this.inQueue = false
  }

  loadObject () {
    let hObject = this
    OfficeR06.loadRequest = true
    BABYLON.SceneLoader.LoadAssetContainerAsync('static/assets/OfficeR06/', 'OfficeR06.babylon', window.scene).then(function (container) {
      for (let i = 0; i < container.meshes.length; i++) {
        container.meshes[i].isVisible = false
      }
      hObject.lod(container.meshes, 3000)
      container.addAllToScene()

      OfficeR06.meshes = container.meshes
    })
  }

  register () {
    if (OfficeR06.meshes.length) { // Se puede registrar el objeto puesto que ya se pueden crear instancias
      // Se marca que ya queda registrado, para que en un siguiente registro no se registre mas de una vez
      this.registered = true

      let newInstances = []

      for (let i = 0; i < OfficeR06.meshes.length; i++) {

        // Crea clones para los mesh que se definen como widgets (porque no pueden compartir texturas)
        if (this.getIndexWidgetByMeshName(OfficeR06.meshes[i].name) !== -1) {
          newInstances.push(OfficeR06.meshes[i].clone(OfficeR06.meshes[i].name))
          newInstances[newInstances.length - 1].isVisible = true
        }
        else { // Crea instancias para los que no requieren cambiar propiedades
          newInstances.push(OfficeR06.meshes[i].createInstance(OfficeR06.meshes[i].name))
        }
        //Asignando el padre correspondiente en newInstances según la misma relación en el arreglo original meshes
        if (OfficeR06.meshes[i].parent !== undefined) {
          newInstances[i].parent = newInstances.find(mesh => mesh.name === OfficeR06.meshes[i].parent.name)
        }
      }

      this.objectConfigurations(newInstances)

      this.setup()
    } else {
      if (OfficeR06.loadRequest === false) { // La primera vez que se desea registrar el objeto se debe cargar desde el servidor
        this.loadObject()
      }
      // Se agrega el objeto a la cola para reintentar posteriormente
      if (!this.inQueue) { // Se agrega sólo si aún no se ha agregado a la cola
        this.inQueue = true
        window.hScene.hObjectsRegisterQueue.push(this)
      }
    }
  }

  setup () {
    this.getMeshByName('hidden').isVisible = false
    this.getMeshByName('paredA').dispose()
    this.getMeshByName('exteriorA').dispose()
    this.getMeshByName('pergolaB').dispose()

    // Set activators
    // this.getMeshByName('activator.003').checkCollisions = false
    // this.getMeshByName('activator.003').material = window.scene.getMaterialByName('activator')

    // this.getMeshByName('door_activator').dispose()
    // this.getMeshByName('band_activator').dispose()
  }

  openDoor1 () {

  }
  // activate_door () {
  //   console.log('...')
  // }
}



// WEBPACK FOOTER //
// ./src/hobjects/OfficeR06.js